import React, { useCallback, useEffect, useState } from "react"
import dayjs from "dayjs"
import { PlusCircleIcon } from "@heroicons/react/outline"
import { Refresh } from "@mui/icons-material"
import { useHistory } from "react-router-dom"
import Button from "../../../components/Button"
import { Routes } from "../../../constants"
import NotificationListMintCal from "../../../components/NotificationListMintCal"
import { useApi } from "../../../contexts/ApiContext"
import { useAuth } from "../../../contexts/AuthContext"


const MintCalendars = React.memo(() => {
  const history = useHistory()
  const {
    isLoadingCollections,
    retrieveMintCalendar,
    refreshCollections,
  } = useApi();

  const { isCurrentUserAdmin, setIsLoadingOverlayDisplay, getUserJWT, currentUserMetadata } = useAuth()

  const [pending, setPending] = useState<any[]>([])
  const [approved, setApproved] = useState<any[]>([])
  const [rejected, setRejected] = useState<any[]>([])

  const isAdmin = isCurrentUserAdmin();

  const onAddNewCollection = useCallback(() => {
    history.push(`${Routes.MINT_CALENDAR}/`)
  }, [history])

  const onRefresh = useCallback(async () => {
    setIsLoadingOverlayDisplay(true)
    if (currentUserMetadata?.userId !== undefined) {
      const variables = isAdmin ? { orderBy: "launchDate", launchDate: `>= ${dayjs(new Date()).format("YYYY-MM-DD")}` } : { creatorId: currentUserMetadata?.userId, orderBy: "launchDate", launchDate: `>= ${dayjs(new Date()).format("YYYY-MM-DD")}` }
      const pending: any = await retrieveMintCalendar({ ...variables, isApproved: false, isRejected: false })
      const approved: any = await retrieveMintCalendar({ ...variables, isApproved: true })
      const rejected: any = await retrieveMintCalendar({ ...variables, isRejected: true })
      setPending(pending)
      setApproved(approved)
      setRejected(rejected)
    }
    setIsLoadingOverlayDisplay(false)
  }, [getUserJWT])

  useEffect(() => {
    onRefresh()
  }, [])

  return (
    <div className="flex flex-col w-11/12 mx-auto mb-12">
      <div className="mt-8 flex flex-row mb-4 justify-between items-center sm:flex-row">
        <h1 className="font-semibold text-3xl text-left">
          MINT CALENDAR MANAGEMENT
        </h1>

        <div className="w-full sm:w-auto flex items-center space-x-4">
          <Button
            type="button"
            className="mb-0 sm:mb-2 w-auto btn bg-kyzzen-primary border border-gray-70 flex items-center text-gray-70"
            onClick={onAddNewCollection}
          >
            ADD NEW
            <PlusCircleIcon className="h-5 inline ml-2" />
          </Button>
          <Button
            type="button"
            className="mb-0 sm:mb-2 w-auto btn  bg-kyzzen-secondary text-gray-100 flex items-center"
            onClick={onRefresh}
          // disabled={isLoadingCollections}
          >
            REFRESH
            <Refresh className="h-5 inline" />
          </Button>
        </div>
      </div>

      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">PENDING APPROVAL</h2>
        <NotificationListMintCal
          mintCalendars={pending}
          state="pending"
        />
      </div>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">APPROVED</h2>
        <NotificationListMintCal
          mintCalendars={approved}
          state="approved"
        />
      </div>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">REJECTED</h2>
        <NotificationListMintCal
          mintCalendars={rejected}
          state="rejected"
        />
      </div>
    </div>
  )
})

export default MintCalendars
